<template>


    <Transition name="modal-fade">
        <div v-if="isdisplay" class="cf-overlay" @click.self="close">
            <Transition name="modal-slide">
                <div v-if="isdisplay" class="cf-dialog cf-dialog--lg">

                    <div class="cf-modal-head cf-dialog-head">
                        <div class="cf-modal-head__main">
                            <span class="cf-modal-head__icon"><i class="ri-tools-line"></i></span>
                            <div>
                                <h4 class="cf-dialog-title">{{titlemodal}}</h4>
                                <p class="cf-modal-head__sub">Utilitaire caisse</p>
                            </div>
                        </div>
                        <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
                    </div>

                    <div class="cf-dialog-body">



                    <div class="box  overflow-hidden">
                        <div class="box-header justify-between " style="display: block">

                            <div class="flex items-start gap-3 p-3 mb-2 rounded-md border-l-4" style="background: #fff8e1; border-color: #f59e0b;">
                                <span style="font-size: 1.4rem; line-height:1; color:#b45309;">⚠</span>
                                <div style="color:#92400e; font-size:0.875rem;">
                                    <strong style="display:block; margin-bottom:4px; text-transform:uppercase; letter-spacing:.03em;">
                                        Opération irréversible
                                    </strong>
                                    Cette opération va corriger <strong>toutes</strong> les opérations de transfert de caisse mal effectuées
                                    dans la période du <strong>2026-05-01</strong> au <strong>2026-06-30</strong>.
                                    Elle ne peut pas être annulée après confirmation.
                                </div>
                            </div>

                        </div>


                        <div class="box-body !p-0 mybodyheight300px">

                            <div class="grid grid-cols-12 gap-4">

                                <div class="xl:col-span-12 col-span-12">

                                    <div class="space-y-2">
                                        <label class="text-capitalize ti-form-label dark:text-defaulttextcolor/70 mb-0">Caisse</label>
                                        <select v-model="Items.c" class="my-auto ti-form-input  rounded-sm ti-form-select rounded-sm
                                                                    !py-2 !px-3">
                                            <option :value="null">Sélectionner une caisse</option>
                                            <option v-for="(caisse,index) of filterdata" :value="caisse" :key="index">{{caisse.name}}</option>

                                        </select>
                                    </div>


                                </div>


                                <div class="xl:col-span-6 col-span-12">
                                    <div class="space-y-2">
                                        <label >Période du </label>
                                        <input class="w-full" type="date" disabled :value="Items.db" placeholder="Date début">
                                    </div>

                                </div>

                                <div class="xl:col-span-6 col-span-12">

                                    <div class="space-y-2">
                                        <label >Au&nbsp;</label>
                                        <input class="w-full" disabled type="date" :value="Items.df" placeholder="Date fin">
                                    </div>
                                </div>




                                <div class="xl:col-span-12 col-span-12">

                                    <center>
                                        <button @click="btnouinonmiseajour" style="text-transform: uppercase"  type="button" class="ti-btn bg-primary text-white m-1">
                                            Mise à jour des factures annulée
                                        </button>
                                    </center>

                                </div>


                            </div>

                        </div>


                    </div>






                </div>
                <div class="cf-dialog-foot">


                    <button @click="close" type="button" class="ti-btn ti-btn-secondary-full" >
                        Fermer
                    </button>


                </div>
                </div>
            </Transition>
        </div>
    </Transition>

    <okouinoncorrectiondestransfertdecaisseapproc ref="okouinoncorrectiondestransfertdecaisseapproc"></okouinoncorrectiondestransfertdecaisseapproc>


</template>

<script>
    import okouinoncorrectiondestransfertdecaisseapproc from "@/components/views/pages/setting/utilitaires/caisse/okouinoncorrectiondestransfertdecaisseapproc.vue";


    const axios =require('axios');


    import {currentDate, randomString} from "@/allfunction";
    import * as JwtService from "@/common/jwt.service";

    export default {
        /* eslint-disable */
        name: "formsupp",

        watch: {



        },
        computed:{


            filterdata(){

                let mvalue=this.datatablesoldecaisse;


                if (this.pidcaisse!==''){
                    let t=this;
                    mvalue = mvalue.filter( function (post) {
                        return    post.pid.toString().toLowerCase().includes(t.pidcaisse.toString().toLowerCase())

                    })

                }



                return  mvalue ;
            },

        },
        components: {
            okouinoncorrectiondestransfertdecaisseapproc
        },

        data() {
            return {
                isdisplay:false,
                titlemodal:"",
                datatablesoldecaisse:[],
                messageerror:"",
                messagesucces:"",
                pidcaisse:"",
                Items:{},

            };
        },
        methods: {



            async load(){



                this.$store.dispatch('lancerchargement',true)
                const t = this;
                let url=process.env.VUE_APP_API_URL+'/onoeofienfneioefezp849418119815191981dsdsc1dscds9/'+randomString(200)+'/profil/'+this.$store.state.appsociete+'/allprofiluser/'+randomString(200);
                let response =   axios  .get(url,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })

                let res= await response
                    .then(function (res){
                        t.$store.dispatch('lancerchargement',false)

                        if(res.data.success){

                            t.datatable=[];
                            t.datatable=res.data.m;
                            t.dataoptions=res.data.moptions;
                            //t.alldata=res.data.alldata;
                             t.isdisplay=true;

                        }
                        else{
                            t.datatable=[];
                           // t.alldata=[];
                            t.dataoptions=res.data.moptions;

                            t.isdisplay=true;

                        }


                    })
                    .catch((error)=>{

                            t.$store.dispatch('lancerchargement',false)
                        }
                    )
                    .finally(() =>{

                        t.$store.dispatch('lancerchargement',false)


                    })




            },



            close(){

                this.isdisplay=false;

                //this.$emit('closed');

            },



            async loadsoldebanque() {


                const t = this;
                let url=process.env.VUE_APP_API_URL+'/egl745874tb771714dfe/dash/graph/587999fffsssdfffsuiviedescaisses784517788/'+randomString(280)+'/'+this.$store.state.appsociete+'/'+randomString();
                let response =   axios  .get(url,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })

                await response
                    .then(response => {

                        if (response.data.success){

                            t.datatablesoldecaisse=response.data.cc


                        }
                        else{


                            t.datatablesoldecaisse=[]

                        }


                    })
                    .catch(

                        error => toastr['error']( "Une erreur est subvenue. <br/> veuillez actualiser la page.",
                            "<b></b>")
                    )
                    .finally(() =>  this.$store.dispatch('lancerchargement',false))



            },



            btnouinonmiseajour(){

                if (this.Items.c===null){

                    toastr['error']( "Veuillez sélectionner une caisse. ","<b></b>");
                    return
                }

                if (this.Items.db===null || this.Items.db==="" ||
                    this.Items.df===null || this.Items.df===""){

                    toastr['error']( "Veuillez sélectionner une période valide. ","<b></b>");
                    return
                }


                let titlemodal=`VOULLEZ-VOUS VRAIMENT CORRIGER LES TRANSFERTS DE CAISSE MAL EFFECTUES A LA CAISSE ${this.Items.c.name}
                sur la période du ${this.Items.db} au ${this.Items.df}  ?`;

                this.$refs.okouinoncorrectiondestransfertdecaisseapproc.show(titlemodal,this.Items);


            },

            show(pidcaisse="",datedouverture=currentDate()){

                /*this.Items={
                    c:null,
                        db:currentDate(),
                        df:currentDate(),
                }*/

              this.Items={
                c:null,
                db:'2026-05-01',
                df:'2026-06-30',
                datedouverture
              }

                this.messagesucces="";
                this.messageerror="";
                this.pidcaisse=pidcaisse;
                this.titlemodal="Correction des transferts de caisse mal effectués";
                /* this.datatable=listdata
                 */

               // this.load()

                this.loadsoldebanque()


                this.isdisplay=true;



            },






        },
        mounted() {

            // this.loaddata();
        }




    }
</script>

<style scoped>
/* Charte cf-/ds- : tokens uniquement (light-only) */
.cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
.cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; max-height:94vh; overflow:hidden; }
.cf-dialog--lg { max-width:760px; }
.cf-dialog-head { display:flex; align-items:center; justify-content:space-between; padding:1rem 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
.cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
.cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }
.cf-dialog-body { padding:1.1rem 1.25rem; overflow-y:auto; flex:1; }
.cf-dialog-foot { display:flex; align-items:center; justify-content:flex-end; gap:0.6rem; padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }
.cf-th { background:var(--cf-surface-alt)!important; color:var(--cf-ink)!important; font-weight:600; font-size:0.75rem; letter-spacing:0.02em; }
.cf-actions { display:inline-flex; align-items:center; gap:4px; }
.cf-iconbtn { height:2rem; width:2rem; display:inline-flex; align-items:center; justify-content:center; border:none; border-radius:var(--cf-radius-sm); cursor:pointer; font-size:1rem; transition:all 0.15s; background:var(--cf-surface-alt); color:var(--cf-muted); }
.cf-iconbtn--primary:hover { background:rgb(var(--primary) / 0.12); color:rgb(var(--primary)); }
.cf-iconbtn--danger:hover { background:rgb(var(--danger) / 0.12); color:rgb(var(--danger)); }
.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
.modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.25s ease; }
.modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(-16px); }
@media (max-width:768px) { .cf-dialog--lg { max-width:100%; } }
</style>